import { type DefaultTableConfig, TableManager } from "@relex-solutions/fragments/TableManager"
import type { TFunction } from "i18next"
import { useId } from "react"
import { useTranslation } from "react-i18next"
import { CustomerList } from "../components/CustomerList/CustomerList"
import { CUSTOMER_COLUMN_IDS } from "../constants/customerTableColumns"

const TABLE_MANAGER_KEYS = [
  "previewTooltipWarning",
  "cancelBtn",
  "saveBtn",
  "closePreviewBtn",
  "newGroup",
  "newGroupTooltip",
  "columnManagerSubtitle",
  "optionsTitle",
  "confirmSaveBtn",
  "confirmSaveCancelBtn",
  "confirmSaveTitle",
  "confirmSaveMessage"
] as const

const createTableManagerText = (translator: TFunction) => {
  const translationPrefix = "customers.tableManager"

  const result = TABLE_MANAGER_KEYS.reduce(
    (acc, key) => {
      acc[key] = translator(`${translationPrefix}.${key}`)
      return acc
    },
    {} as Record<(typeof TABLE_MANAGER_KEYS)[number], string>
  )

  return {
    ...result,
    showPreviewBtn: (count: number) => translator(`${translationPrefix}.showPreviewBtn`, { count })
  }
}

export function CustomerListPage() {
  const { t } = useTranslation()

  const defaultConfig: DefaultTableConfig = {
    title: t("customers.pageTitle"),
    layout: [
      CUSTOMER_COLUMN_IDS.NAME,
      CUSTOMER_COLUMN_IDS.SALESFORCE_ID,
      CUSTOMER_COLUMN_IDS.RELATIONSHIP_TYPE,
      CUSTOMER_COLUMN_IDS.SUB_TYPE,
      CUSTOMER_COLUMN_IDS.SDM_EMAIL,
      CUSTOMER_COLUMN_IDS.ID,
      CUSTOMER_COLUMN_IDS.TAX_NUMBER
    ]
  }

  const text = createTableManagerText(t)

  return (
    <TableManager id={useId()} defaultConfig={defaultConfig} text={text}>
      <CustomerList />
    </TableManager>
  )
}
